module.exports = new __parcel__URL__("jpd-try-end-learn.db348fdd.svg").toString();